export const borderRadiusValues = {
  border_radius_4px: "4px",
  border_radius_5px: "5px",
  border_radius_8px: "8px",
  border_radius_15px: "15px",
  border_radius_20px: "20px",
  border_radius_50p: "50%",
};
